<!--suppress ALL -->
<template>
    <div class="visit-container full-height"
         v-bind:class="{'blurred': showSelectSurveyDialog
         || showClosedVisitDialog || showWrongVisitIdDialog || showAddAttachmentDialog }"
    v-if="state !== null">
        <div>
            <md-dialog :md-active.sync="showSelectSurveyDialog" class="select-survey-dialog"
                       @md-closed="closeAddSurveysDialog()">
                <div class="select-survey-dialog__header">
                    <span class="select-survey-dialog__title">Wybierz formularz badania</span>
                    <div @click="closeAddSurveysDialog()">
                        <md-icon class="select-survey-dialog__close-icon"
                                 :md-src="require('../../assets/ic_close.svg')"/>
                    </div>
                </div>
                <div class="select-survey-dialog__content" v-if="state">
                    <div class="select-survey-dialog__content-search">
                        <md-field class="search-survey-field">
                            <md-icon>search</md-icon>
                            <label>Wyszukaj badanie</label>
                            <md-input v-model="searchedSurvey"></md-input>
                        </md-field>
                    </div>
                    <md-content class="md-layout md-scrollbar">
                        <div v-for="(child, index) in getPossibleSurveys()"
                             v-bind:key="index"
                             v-if="!isSurveySelected(child.id)"
                             class="md-layout-item md-xlarge-size-20
                            md-large-size-25 md-medium-size-33
                            md-small-size-50 md-xsmall-size-100">
                            <md-checkbox v-model="possibleSurveysSelected"
                                         v-bind:value="child"
                                         class="md-primary">
                                {{formatPossibleSurveyNamePart1(child.name)}}<br>
                                {{formatPossibleSurveyNamePart2(child.name)}}
                            </md-checkbox>
                        </div>
                    </md-content>
                    <div class="select-survey-dialog__content-action">
                        <btn text="Dodaj Badanie" :disabled="possibleSurveysSelected.length === 0"
                             @click="onAddSurveysBtnClick"></btn>
                    </div>
                </div>
            </md-dialog>
            <md-dialog :md-active.sync="showClosedVisitDialog" class="closed-visit-dialog"
                       :md-close-on-esc="false" :md-click-outside-to-close="false">
                <span class="md-title">Sukces</span>
                <md-content>
                    Zakończyłeś wizytę.
                </md-content>
            </md-dialog>
            <md-dialog :md-active.sync="showWrongVisitIdDialog" class="wrong-visit-dialog"
                       :md-close-on-esc="false" :md-click-outside-to-close="false">
                <span class="md-title">Uwaga</span>
                <md-content>
                    Wizyta nie istnieje.
                </md-content>
            </md-dialog>
            <md-dialog :md-active.sync="showAddAttachmentDialog" class="add-attachment-dialog"
                       @md-closed="closeAddAttachmentDialog()">
                <div class="add-attachment-dialog__header">
                    <span class="add-attachment-dialog__title">Dodaj załącznik</span>
                    <div @click="closeAddAttachmentDialog()">
                        <md-icon class="add-attachment-dialog__close-icon"
                                 :md-src="require('../../assets/ic_close.svg')"/>
                    </div>
                </div>
                <div class="add-attachment-dialog__content" v-if="state" v-bind:class="{'blurred' : addingFile === true}">
                    <div class="add-attachment-dialog__content-fields">
												<div class="fields-container">
													<md-field>
															<label>Tytuł pliku</label>
															<md-input v-model="attachment.title"></md-input>
													</md-field>
												</div>
												<div class="fields-container">
														<md-field class="description">
																<label>Opis pliku</label>
																<md-textarea @keydown="onKeyDown" v-model="attachment.description"></md-textarea>
														</md-field>
                            <p class="description_limit">{{ attachment.description.length }} / {{ attachmentMaxDescriptionLength }} znaków</p>
												</div>
												<file id="add-attachment" class="display-block" :text="addFileText"
													@change="onFileSelect"
												></file>
                    </div>
                    <div class="add-attachment-dialog__content-action">
                        <btn text="Zapisz" 
													:disabled="!attachment.files"
													@click="addAttachment"
												></btn>
                    </div>
										<div class="spinner-container" v-if="addingFile === true">
											<md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
										</div>
                </div>
            </md-dialog>
        </div>
        <mq-layout :mq="['xs', 'sm']">
            <img v-on:click="mobileMenuVisible = !mobileMenuVisible"
                 v-if="!mobileMenuVisible"
                 class="visit-container__menu-icon"
                 src="../../assets/navbar_mobile.svg">
        </mq-layout>
        <transition name="fade">
            <div class="left-bar" v-if="mobileMenuVisible ||
                                        ($mq === 'md' || $mq === 'lg' || $mq === 'xl')">
                <mq-layout class="left-bar__back-icon-wrapper survey-section-margin" :mq="['xs', 'sm']">
                    <img v-on:click="mobileMenuVisible = !mobileMenuVisible"
                         class="left-bar__back-icon"
                         src="../../assets/ic_back_arrow.svg">
                </mq-layout>
                <p class="left-bar__title survey-section-margin">Badania</p>
                <btn class="display-block survey-section-margin" text="+ Dodaj badanie"
                     @click="onAddSurveyBtnClick" v-if="state && !state.readonlyMode"></btn>
                <md-divider class="surveys-divider"></md-divider>
                <md-content class="survey-container md-scrollbar">
                    <div v-if="state">
                        <div style="margin-right: 10px;" v-for="(item, index) in state.surveysList"
                             v-bind:key="index"
                             @click="onSurveySelect(item)"
                             v-bind:class="{
                         active: (state.selectedSurvey && state.selectedSurvey.id === item.id),
                         touched: isSurveyTouched(item)}"
                             class="survey-container__item"
                             v-bind:style="{'border-color': '#00BDB7',
                                            color: '#00BDB7'}">
                            <div class="survey-container__item__icon"
                                 v-bind:style="{'background-color': getSurveyColor(item),
                                 'opacity':'0.5'}">
                                <img v-bind:src="require('../../assets/' +
                                     getSurveyIcon(item.name) +'.svg')">
                            </div>
                            <span class="survey-container__item__name">
                                {{formatPossibleSurveyNamePart1(item.name)}}<br>
                                {{formatPossibleSurveyNamePart2(item.name)}}</span>
                            <div class="survey-container__item__remove-icon">
                                <img v-show="!item.isDefault && (state && !state.readonlyMode)"
                                     src="../../assets/ic_bin_gray.svg"
                                     class=""
                                     @click="onRemoveSurvey(item.id)">
                            </div>
                        </div>
                    </div>
                </md-content>
                <!--<md-divider></md-divider>-->
                <div class="left-bar__container">

                    <div class="left-bar__title-container " v-on:click="addAttachmentVisible = !addAttachmentVisible">
                        <div class="left-bar__counter" v-if="state.attachmentsList.length > 0">{{state.attachmentsList.length}}</div>
                        <p class="left-bar__title" v-bind:class="{'nullAttachment' : state.attachmentsList.length === 0 }">{{ $t('attachments') }}</p>
                        <div class="left-bar__arrow"  v-bind:class="{rotate180 : addAttachmentVisible}"></div>
                    </div>
                    <btn class="btn-add-attachment btn-outline display-block" text="+ Dodaj"
						@click="openAddAttachmentDialog" 
						v-if="(state && !state.readonlyMode) && (addAttachmentVisible === true)"
                    ></btn>
                    <md-divider class="attachments-divider"
                                v-if="addAttachmentVisible"></md-divider>
                    <md-content v-if="(addAttachmentVisible) && (state.attachmentsList.length > 0)"
                                class="attachments-list-container md-scrollbar">
                        <div v-if="state" id="attachments">
                            <div v-for="(item, index) in state.attachmentsList"
                                 v-bind:key="index"
                                 class="attachments-list-container__item">
                                <div>
                                    <a v-bind:href="getAttachmentDownloadLink(item.id)" target="_blank">
                                        <img class="attachments-list-container__item__att-icon"
                                             src="../../assets/ic_attachment.svg">
                                        <span class="attachments-list-container__item__name">
                                         {{item.fileName}}</span>
                                    </a>
                                </div>
                                <img v-if="state && !state.readonlyMode"
                                     src="../../assets/ic_bin_gray.svg"
                                     class="attachments-list-container__item__remove-icon"
                                     @click="onRemoveAttachment(item.id)">
                                <div class="attachment-spinner-container" v-bind:ref="item.id">
                                    <md-progress-spinner :md-diameter="25"
                                                         md-mode="indeterminate"></md-progress-spinner>
                                </div>
                            </div>
                        </div>
                    </md-content>
                </div>
            </div>
        </transition>
        <div class="main-wrapper"
             v-bind:class="{'blurred': mobileMenuVisible}">
            <div class="visit-header">
                <div class="visit-header__container text-center">
                    <btn class="float-right" v-if="state && !state.closedVisit"
                         v-bind:text="$t('endVisit')"
                         @click="showCloseVisitDialog()"></btn>
                </div>
            </div>
            <div class="main-container">
                <div class="main">
                    <div class="main-header text-center">
                        <span class="color-brand">{{generateHeader()}} </span>
                    </div>
                    <div class="survey-form">
                        <survey-root-node v-if="state && state.selectedSurvey"
                                          v-bind:field="state.selectedSurvey"
                                          @nodeChange="onSurveyChange">
                        </survey-root-node>
                        <div v-if="!state || !state.selectedSurvey" class="chose-survey-container">
                            <mq-layout :mq="['xs', 'sm']">
                                <div class="img_mobile_container">
                                    <img class="img_mobile_container__arrow" src="../../assets/ic_arrow.svg">
                                    <img class="img_mobile_container__checklist" src="../../assets/Ic_checklist_v2.svg">
                                </div>
                                <p v-if="!state.readonlyMode">Wybierz badanie,<br> które chcesz uzupełnić.</p>
                                <p v-if="state.readonlyMode">Wykonane badania.</p>
                            </mq-layout>
                            <mq-layout :mq="['md', 'lg', 'xl']">
                                <div class="img_desktop_container">
                                    <img class="img_desktop_container__arrow" src="../../assets/ic_arrow.svg">
                                    <img class="img_desktop_container__checklist" src="../../assets/Ic_checklist_v2.svg">
                                </div>
                                <p v-if="!state.readonlyMode">Wybierz badanie,<br>które chcesz uzupełnić.</p>
                                <p v-if="state.readonlyMode">Wykonane badania.</p>
                            </mq-layout>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <md-snackbar md-position="center" :md-duration="snackbar.duration"
                     :md-active.sync="snackbar.show" md-persistent>
            <span>{{snackbar.text}}</span>
            <img class="snackbar-close-icon" src="../../assets/ic_close.svg"
                 @click="snackbar.show = false">
        </md-snackbar>
    </div>
</template>

<script>
/* eslint-disable no-param-reassign */

import store from '../../store';
import {
  SURVEY_SELECT, POSSIBLE_SURVEY_GET, SURVEY_ADD,
  ATTACHMENTS_LIST_GET, ATTACHMENT_SET, ATTACHMENT_DELETE, VISIT_SURVEYS_GET,
  SURVEY_DELETE, SET_PROGRESS, BODY_PART_DATA_GET, POINTER_GET,POINTER_ADD,
  SET_READONLY_MODE,
} from '../../store/action-modulation.type';
import VisitService from '../../services/visit.service';
import AuthService from '../../services/auth.service';
import { API_URL } from '../../../config/env';

const surveysColors = [
  '25e491', '75fd30',
  '29de29', '2fd23b',
  'e5fd36', '38f2c7',
  '00bdb7'];

export default {
  name: 'Visit',
  data: () => ({
		state: null,
		attachment: {
			files: null,
			title: '',
			description: '',
		},
		attachmentMaxNameLength: 50,
		attachmentMaxDescriptionLength: 250,
		addingFile: false,
		mobileMenuVisible: false,
		addAttachmentVisible: false,
		survey: [],
		colorArrayIndex: 0,
		possibleSurveysSelected: [],
		searchedSurvey: '',
		showSelectSurveyDialog: false,
		showClosedVisitDialog: false,
		showWrongVisitIdDialog: false,
		showAddAttachmentDialog: false,
		snackbar: {
			show: false,
			text: '',
			durtion: 4000,
		},
		partData: [],
		activeParts: [],
  }),
  methods: {
      fetchPointers() {
          store.dispatch(POINTER_GET, this.$route.params.visitId).then((data) => {
              data.data.forEach((element) => {
                  this.activeParts.push(element.id);
              });
          });
          store.commit(POINTER_ADD, this.activeParts);
      },
      fetchBodyParts() {
          store.dispatch(BODY_PART_DATA_GET).then((data) => {
              store.commit(BODY_PART_DATA_GET, data.data);
              this.partData = store.state.skeleton.partsData;
          });
      },
    generateHeader() {
        let result ='';
        this.partData.forEach((item) => {
            item.children.forEach((child)=>{
                if (this.activeParts.filter(element => element === child.id).length > 0 ){
                result += `${child.name} ${item.name}  | `;
            }
            child.children.forEach((secondChild)=>{
               if (this.activeParts.filter(element => element === secondChild.id).length > 0 ){
                   result += `${secondChild.name} ${child.name}  | `;
               }
            })
            })
        });
        result = result.toUpperCase();
        result = result.slice(0,-2);
        return result;
    },

    checkFieldValue(field) {
      let flag = false;
      if ((field.value !== undefined) && (field.value !== null) && (field.value !== '')) {
        flag = true;
        if (field.type === 'RECOGNITIONS') {
          const fieldValue = JSON.parse(field.value);
          if (fieldValue.recognitions[0].recognition || fieldValue.recognitions[0].comments) {
            flag = true;
          } else {
            flag = false;
          }
        } else if (field.type === 'EXERCISES') {
          const fieldValue = JSON.parse(field.value);
          if (fieldValue.exercises[0].name || fieldValue.exercises[0].series || fieldValue.exercises[0].count || fieldValue.exercises[0].comments) {
            flag = true;
          } else {
            flag = false;
          }
        } else if (field.type === 'CHECKBOX') {
          if (field.value === '0') {
            flag = false;
          } else {
            flag = true;
          }
        }
      }

      if (field.children.length > 0) {
        field.children.forEach((item) => {
          if (this.checkFieldValue(item)) {
            flag = true;
          }
        });
      }
      return flag;
    },
    isSurveyTouched(survey) {
      let flag = false;
      if (survey.children.length > 0) {
        survey.children.forEach((item) => {
          if (this.checkFieldValue(item)) {
            flag = true;
          }
        });
      }
      return flag;
    },
    getSurveyColor(item) {
      if (!item.color) {
        if (this.colorArrayIndex > 6) {
          this.colorArrayIndex = 0;
        }
        item.color = surveysColors[this.colorArrayIndex];
        this.colorArrayIndex += 1;
      }

      return `#${item.color}`;
    },
    getSurveyIcon(surveyName) {
      switch (surveyName) {
        case 'Wywiad': {
          return 'ic_wywiad';
        }
        case 'przebieg terapii': {
          return 'ic_przebieg_terapi';
        }
        case 'rozpoznania': {
          return 'ic_rozpoznania';
        }
        case 'zalecenia': {
          return 'ic_zalecenia';
        }
        default: {
          return 'ic_entry_incompleted';
        }
      }
    },
    onSurveyChange() {
    },
    getAttachmentDownloadLink(attachmentId) {
      return `${API_URL}appointments/${this.$route.params.visitId}/attachments/${attachmentId}?x-access-token=${AuthService.getToken()}`;
    },
    onRemoveSurvey(surveyId) {
      this.$root.confirmDialog.title = 'Usuń badanie';
      this.$root.confirmDialog.content = 'Czy na pewno chcesz usunąć wybrane badanie?';
      this.$root.confirmDialog.active = true;
      this.$root.confirmDialog.onConfirm = () => {
        if (this.state.selectedSurvey && this.state.selectedSurvey.id === surveyId) {
          store.dispatch(SURVEY_SELECT, null);
        }
        store.dispatch(SURVEY_DELETE, [this.$route.params.visitId, surveyId]);
      };
    },
    onRemoveAttachment(attachmentId) {
      const attachments = document.getElementById('attachments');
      const beforeDeleteCount = attachments.childElementCount;
      this.$root.confirmDialog.title = 'Usuń załącznik';
      this.$root.confirmDialog.content = 'Czy na pewno chcesz usunąć wybrany załącznik?';
      this.$root.confirmDialog.active = true;
      this.$root.confirmDialog.onConfirm = () => {
        this.$refs[attachmentId][0].classList.add('active');
        store.dispatch(ATTACHMENT_DELETE, [this.$route.params.visitId, attachmentId]);
        const t = setInterval(() => {
          const afterDeleteCount = attachments.childElementCount;
          if (beforeDeleteCount > afterDeleteCount) {
            clearInterval(t);
            for (let i = 0; i < attachments.childNodes.length; i++) {
              if (attachments.childNodes[i].childNodes[4].classList.contains('active')) {
                attachments.childNodes[i].childNodes[4].classList.remove('active');
              }
            }
          }
        }, 250);
      };
    },
    onFileSelect(file) {
			this.attachment.files = file.files;
    },
    isSurveySelected(surveyId) {
      return this.state.surveysList.filter(survey => survey.id === surveyId).length > 0;
    },
    onSurveySelect(item) {
      store.dispatch(SURVEY_SELECT, item);

      if (this.mobileMenuVisible) {
        this.mobileMenuVisible = !this.mobileMenuVisible;
      }
    },
    fetchData() {
      store.dispatch(VISIT_SURVEYS_GET, this.$route.params.visitId).then(() => {
        let readonlyMode = this.state.closedVisit;
        if (store.state.access.accessLevel == "owner" && readonlyMode) readonlyMode = false;
        store.dispatch(SET_READONLY_MODE, readonlyMode);
      });
      store.dispatch(POSSIBLE_SURVEY_GET, this.$route.params.visitId);
      store.dispatch(ATTACHMENTS_LIST_GET, this.$route.params.visitId);
    },
    onAddSurveyBtnClick() {
      this.showSelectSurveyDialog = true;
    },
    onAddSurveysBtnClick() {
      store.dispatch(SURVEY_ADD, [this.$route.params.visitId, this.possibleSurveysSelected]);
      this.closeAddSurveysDialog();
    },
    getPossibleSurveys() {
      if (this.searchedSurvey) {
        // eslint-disable-next-line
				return this.state.possibleSurveys.filter((survey) => {
          return survey.name.toLowerCase().indexOf(this.searchedSurvey.toLowerCase()) !== -1;
        });
      }
      return this.state.possibleSurveys;
    },
    closeAddSurveysDialog() {
      this.possibleSurveysSelected = [];
      this.showSelectSurveyDialog = false;
    },
    showCloseVisitDialog() {
      this.$root.confirmDialog.title = 'Zakończ wizytę';
      this.$root.confirmDialog.content = 'Czy jesteś pewny, że chcesz zakończyć wizytę?';
      this.$root.confirmDialog.active = true;
      this.$root.confirmDialog.onConfirm = () => {
        this.closeVisit();
      };
    },
      formatPossibleSurveyNamePart1(name){
          const n = name.indexOf("-");
          if ( n > 0) {
              name = name.charAt(0).toUpperCase() + name.substring(1);
              let name1 = name.substr(0, n + 1);
              let result = name1;
              return result;
          }else{
              name = name.charAt(0).toUpperCase() + name.substring(1);
              return name;
          }
      },
      formatPossibleSurveyNamePart2(name){
          const n = name.indexOf("-");
          if (n > 0) {
              name = name.charAt(0).toUpperCase() + name.substring(1);
              let name2 = name.substr(n + 1);
              let result = name2;
              return result;
          }
      },
    closeVisit() {
      VisitService.closeVisit(this.$route.params.visitId)
        .then(() => {
          this.showClosedVisitDialog = true;
            var message = {
                isClose: true
            };
            setTimeout(function(){
                let frame = window.open("about:blank", "_self");
                window.parent.postMessage(message, '*');
                frame.close();
            },3000)
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
    handleError(error) {
      if (error && error.response.status === 404) {
        this.showWrongVisitIdDialog = true;
      }
    },
    openAddAttachmentDialog() {
      this.showAddAttachmentDialog = true;
    },
    closeAddAttachmentDialog() {
			this.showAddAttachmentDialog = false;
			this.clearAttachment();
		},
		clearAttachment () {
			this.attachment = {
				files: null,
				title: '',
				description: '',
			};
		},
		validateAttachment () {
			if (!(this.attachment.title.length <= this.attachmentMaxNameLength)) {
					this.$root.alertDialog.title = 'Uwaga';
					this.$root.alertDialog.content = 'Maksymalna długość tytuł pliku to 50 znaków';
          this.$root.alertDialog.active = true;
          return false;
			}
			if (!(this.attachment.description.length <= this.attachmentMaxDescriptionLength)) {
					this.$root.alertDialog.title = 'Uwaga';
					this.$root.alertDialog.content = 'Maksymalna długość opisu pliku to 250 znaków';
					this.$root.alertDialog.active = true;
          return false;
			}
			return this.attachment.files;
		},
		addAttachment () {
			if (this.validateAttachment()) {
				VisitService.uploadAttachment(this.$route.params.visitId, this.attachment)
				.then((data) => {
					store.dispatch(ATTACHMENT_SET, data.data);
					this.snackbar.text = 'Załącznik został przesłany pomyślnie';
					this.snackbar.show = true;
					this.closeAddAttachmentDialog();
				})
				.catch(() => {
					this.$root.alertDialog.title = 'Uwaga';
					this.$root.alertDialog.content = 'Wystąpił problem podczas ładowania załącznika.';
					this.$root.alertDialog.active = true;
				});
			}
		},
    onKeyDown(e){
        if (this.attachment.description.length >= 250) {
          if (e.keyCode !== 8) {
            e.preventDefault();
            return
          }
        }
    },
  },
  computed: {
    getState() {
      return store.state.visit;
		},
		addFileText() {
			return !this.attachment.files ? 'Wybierz załącznik' : 'Wybierz załącznik (plik załączony)'
		},
  },
  created() {
    this.fetchData();
    if ((this.partData)&&(this.activeParts)){
        this.fetchBodyParts();
        this.fetchPointers();
    } else {
        this.partData = store.state.skeleton.partsData;
        this.activeParts = store.state.skeleton.touchedParts;
    }
  },
  watch: {
    getState: {
      handler(state) {
        this.state = state;
      },
      deep: true,
    },
  },
};
</script>

<style src="./Visit.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Visit/Visit.vue